import React from "react";
import ReactDOM from "react-dom";
import "./style/index.css";
import "./style/Admin.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
/*mobilecontext*/
import Provider from "./contexts/Provider";
ReactDOM.render(
  <React.StrictMode>
    <Provider>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
